




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import Nullable from '@/types/nullable';

@Component({})
export default class JobContact extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;

  get jobPhoneHref(): string {
    if(this.job.client.location.contactNumber == null){
      return null;
    }
    
    return `tel:${this.job.client.location.contactNumber}`;
  }
}

